import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import arrowBottom from '../assets/arrow-bottom.png';
 
import mainimg from '../assets/body-bg.png';
import profile from '../assets/profile.png';
import logo from '../assets/logo.png';
import circle from '../assets/circle.svg';
import wave from '../assets/wave.png';
import skype from '../assets/skype.png';

import about1 from '../assets/about1.png';
import about2 from '../assets/about2.png';
import about3 from '../assets/about3.png';
import about4 from '../assets/about4.png';
import about5 from '../assets/about5.png';
import about6 from '../assets/about6.png';

import work_game1 from '../assets/work_game1.png';
import sce from '../assets/sce.jpg';
import wordpress from '../assets/wordpress.png';
import shopware from '../assets/shopware_logo_blue.svg';
import sanity from '../assets/sanity.png';
import quote from '../assets/quote-icon.svg';
import profilephoto from '../assets/photo_profile-png.png';
import profilegreen from '../assets/profile_green.png';
import photodark from '../assets/photo_dark.png';
import photostrip from '../assets/photo_strip.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  email,
  mobile,
  api,
  css,
  figma,
  git,
  html,
  javascript,
  react,
  redux,
  sass,
  typescript,
  vue,
  logo,
  circle,
  skype,
  mainimg,
  profile,
  wave,
  about1,
  about2,
  about3,
  about4,
  about5,
  about6,
  work_game1,
  sce,
  wordpress,
  shopware,
  sanity,
  arrowBottom,
  quote,
  profilephoto,
  profilegreen,
  photodark,
  photostrip,
};